import * as React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { FontAwesomeIcon, findIconDefinition } from '@purposity/icons'
import { FixedText } from '@components/FixedText'
import { Spacer } from '@components/Spacer'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'

export function ClockTag({ date }: { date: Date }) {
  const formattedDate = date
    ? new Intl.DateTimeFormat('en-US', {
        dateStyle: 'long',
      }).format(date)
    : ''
  return (
    <View style={styles.container}>
      <FontAwesomeIcon
        icon={findIconDefinition({ prefix: 'fal', iconName: 'clock' })}
        color={Colors.dotGray}
      />
      <Spacer width={4} noShrink />

      <FixedText lineHeight={1.2}>
        <Text style={styles.tagText}>{formattedDate}</Text>
      </FixedText>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tagText: {
    fontFamily: Fonts.type.alternateBold,
    fontWeight: 'bold',
    fontSize: 13,
    color: Colors.textGray,
    textTransform: 'uppercase',
  },
})

export default ClockTag
